import NiceModal from "@ebay/nice-modal-react";
import { Container } from "@mui/material";
import { requester } from "App";
import { mobileNoFormat, passwordFormat, textFormat, userNameFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import EmailDomainSelector from "components/inputs/email/EmailDomainSelector";
import InputPassword from "components/inputs/signUp/InputPassword";
import InputText from "components/inputs/signUp/InputText";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { validateInputs } from "shared/utils/Utils";
import MobileSignUp from "./MobileSignUp";
import IdentityVerification from "./IdentityVerification";

function MemberSignUp(props) {
    const { id } = useParams();
    const { isMobile } = useContext(BrowserDetectContext);
    const inputs = useRef([]);
    const location = useLocation();
    const [duplicateCheck, setDuplicateCheck] = useState(true);
    const [userName, setUserName] = useState();
    const [password, setPassword] = useState();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    
    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }
    const onDuplicateClick = () => {
        let data = { userName: "", storeId: "root", role: "MEMBER" }
        data.userName = inputs.current[0].getValue();
        // 먼저 형식 유효성 검사를 수행합니다.
        const isFormatValid = userNameFormat.exp.test(data.userName);
        if (!isFormatValid) {
            toast.error("올바른 아이디를 입력해주세요", {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            inputs.current[0].focus();
            return;
        }

        requester.userDuplicateCheck(data, (result) => {

            if (result.data) {
                toast.error("이미 사용중인 아이디입니다", {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });

                inputs.current[0].focus();
                setDuplicateCheck(result.data);
            } else {
                toast.success(t("available"), {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
                setDuplicateCheck(result.data);
            }
        });
    }

    const signUp = () => {

        let data = { storeId: "root", userName: "", password: "", mobileNumber: "", email: "" }
        let addressData = { address: "", addressDetail: "", zipcode: "" }

        if (!duplicateCheck) {
            validateInputs(inputs.current).then((isValid) => {
                if (isValid) {
                    // 유효성 검사를 통과하면, 입력 필드로부터 값을 가져와 data 객체를 업데이트
                    data.userName = inputs.current[0].getValue();
                    data.password = inputs.current[1].getValue();
                    data.mobileNumber = inputs.current[2].getValue();
                    data.email = inputs.current[3].getValue() + '@' + inputs.current[4].getSelectedDomain();
                    // addressData.address = inputs.current[5].getValue();
                    // addressData.addressDetail = inputs.current[6].getValue();
                    // addressData.zipcode = inputs.current[7].getValue();

                    dispatch(HistoryReducer.actions.setLoading(true));
                    requester.memberSignUp(data, (result) => {
                        if (result.code === 0) {
                            setUserName(data.userName);
                            setPassword(data.password);


                            // let row = { type: "Register", data:  data.userName}
                            // techtonicChainRequester.userBalance(row, (result) => {
                            
                            // })
                        } else {
                            toast.error(t("문제가 발생했습니다 관리자에게 문의하세요"), {
                                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                            });
                        }
                        dispatch(HistoryReducer.actions.setLoading(false));
                    });

                    // 이후 데이터 처리 로직...
                } else {
                    toast.error(t("pleaseCheck"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });

                }
            })

        } else {
            toast.error(t("duplicateCheck"), {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
            inputs.current[0].focus();
        }

    }
    /* 국내 주소 관련  */
    const [enroll_company, setEnroll_company] = useState({
        address: '',
        zonecode: ''
    });

    const [popup, setPopup] = useState(false);

    const addressKrModalClick = () => {
        NiceModal.show("addressKr", { onCallback: addressKrCallback });
    }
    const addressKrCallback = (dataFromModal) => {
        
        // 여기에서 모달에서 받은 데이터를 처리합니다.

        setEnroll_company((prevState) => ({
            ...prevState,
            address: dataFromModal.address,
            zonecode: dataFromModal.zonecode // zonecode도 받고 싶다면 이런 식으로 추가할 수 있습니다.
        }));
    };

    


    const addressBtnStyle = {
        backgroundColor: "#4d4f56",
        color: "white",
        padding: "5px 15px",


    }
    return (
        <>
            {
                isMobile
                    ?
                    <IdentityVerification storeCode={location.state && location.state.storeCode} />
                    :
                    <Container>
                        <Container maxWidth={1200}>
                            <VerticalFlex gap={20}>
                                <FlexChild>
                                    <div>
                                        <P size={40} font={"gmarketSansBold"} color={"black"}>Member회원가입</P>
                                    </div>
                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex gap={30}>
                                        <FlexChild width={"20%"} >
                                            <P>아이디 : </P>
                                        </FlexChild>
                                        <FlexChild>
                                            <HorizontalFlex gap={40}>
                                                <FlexChild>
                                                    <InputText ref={el => (inputs.current[0] = el)} placeHolder={"아이디(3글자이상 20자 이하)"} regExp={[textFormat]} />
                                                </FlexChild>
                                                <FlexChild width={"max-content"}>
                                                    <CustomButton text={"중복확인"} onClick={onDuplicateClick} />
                                                </FlexChild>

                                            </HorizontalFlex>

                                        </FlexChild>
                                    </HorizontalFlex>

                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex gap={30}>
                                        <FlexChild width={"20%"} >
                                            <P>비밀번호 : </P>
                                        </FlexChild>
                                        <FlexChild>
                                            <InputPassword ref={el => (inputs.current[1] = el)} signUp placeHolder={"비밀번호(대문자, 소문자,숫자,특수문자 포함)"} placeHolderComfirm={t("password") + t("confirm")} confirmVisible={true} regExp={[passwordFormat]} />
                                        </FlexChild>

                                    </HorizontalFlex>

                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex gap={30}>
                                        <FlexChild width={"20%"} >
                                            <P>전화번호 : </P>
                                        </FlexChild>
                                        <FlexChild>
                                            <InputText ref={el => (inputs.current[2] = el)} placeHolder={"전화번호"} regExp={[mobileNoFormat]} />
                                        </FlexChild>

                                    </HorizontalFlex>

                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex gap={30}>
                                        <FlexChild width={"20%"} >
                                            <P>이메일 : </P>
                                        </FlexChild>
                                        <FlexChild>
                                            <InputText placeHolder={"이메일"} ref={el => (inputs.current[3] = el)} regExp={[textFormat]} />
                                        </FlexChild>
                                        <FlexChild>
                                            <EmailDomainSelector ref={el => (inputs.current[4]) = el} />
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                {/* <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <VerticalFlex gap={30} flexStart>
                                    <FlexChild>
                                        <P>주소 : </P>
                                    </FlexChild>
                                    <FlexChild>
                                        <P>나머지 주소 : </P>
                                    </FlexChild>


                                </VerticalFlex>

                            </FlexChild>
                            <FlexChild >
                                <VerticalFlex flexStart gap={15}>
                                    <FlexChild>
                                        <HorizontalFlex gap={30}>
                                            <FlexChild width={"max-content"}>
                                                <CustomButton style={addressBtnStyle} text={"주소검색"} onClick={addressKrModalClick} />
                                            </FlexChild>
                                            <FlexChild width={"60%"}>
                                                <InputText ref={el => (inputs.current[5] = el)} disabled value={enroll_company.address} regExp={[textFormat]} />
                                            </FlexChild>
                                            <FlexChild>
                                                <InputText disabled value={enroll_company.zonecode} ref={el => (inputs.current[6] = el)} regExp={[textFormat]} />
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                    <FlexChild>
                                        <InputText placeHolder={"나머지 주소"} ref={el => (inputs.current[7] = el)} regExp={[textFormat]} />
                                    </FlexChild>
                                </VerticalFlex>

                            </FlexChild>


                        </HorizontalFlex>

                    </FlexChild> */}
                                <FlexChild>
                                    <CustomButton text={"회원가입"} style={btnStyle} onClick={signUp} />
                                </FlexChild>
                            </VerticalFlex>


                        </Container>
                    </Container>
            }
        </>


    );
}

export default MemberSignUp;